import React from 'react';
import {AccessControlIndicator, defineAccessControlledResource, PoliciesAccessRule} from '@igp/shared/access-control';
import type {
    IBulkApplyStrategy,
    IBulkStrategy,
    PerformStrategyOperationResponse,
    PerformStrategyRequest,
    ValidationStrategyResponse,
} from '@igp/shared/features/bulk-operation';
import type {BaseBulkP2PTransferProps} from '@igp/shared/features/transaction';
import {
    type ApplyP2PTransfersRequest,
    BulkP2PTransferViaFileButton as BaseBulkP2PTransferViaFileButton,
    type LoadP2PTransferStrategyResponse,
    type LoadP2PTransferViaFileStrategyRequest,
    type P2PTransferModel,
    type ValidationP2PTransferRequest,
} from '@igp/shared/features/transaction';
import {useService} from '@igp/shared/ioc-container';
import {EntityType} from '@models';

import {ServiceTypes} from '@ioc-container';
import {withAccessCheck} from '@access-control';
import {agentPolicy} from '@policy-access';

function BulkP2PTransferViaFileButtonInner(props: BaseBulkP2PTransferProps) {
    const loadP2PTransfersStrategy = useService<IBulkStrategy<LoadP2PTransferViaFileStrategyRequest, LoadP2PTransferStrategyResponse>>(
        ServiceTypes.LoadP2PTransferViaFileStrategy
    );
    const applyP2PTransfersStrategy = useService<IBulkApplyStrategy<ApplyP2PTransfersRequest>>(ServiceTypes.ApplyP2PTransfersStrategy);
    const validationP2PTransferStrategy = useService<IBulkStrategy<ValidationP2PTransferRequest, ValidationStrategyResponse>>(
        ServiceTypes.ValidationP2PTransferStrategy
    );
    const performP2PTransfersStrategy = useService<
        IBulkStrategy<PerformStrategyRequest<P2PTransferModel>, PerformStrategyOperationResponse>
    >(ServiceTypes.PerformP2PTransfersStrategy);
    return (
        <BaseBulkP2PTransferViaFileButton
            {...props}
            p2pSettingsEntityType={EntityType.P2PPlayerSettings}
            bulkOperationEntityType={EntityType.BulkOperation}
            loadP2PTransfersStrategy={loadP2PTransfersStrategy}
            applyP2PTransfersStrategy={applyP2PTransfersStrategy}
            validationP2PTransferStrategy={validationP2PTransferStrategy}
            performP2PTransfersStrategy={performP2PTransfersStrategy}
        />
    );
}

const resource = defineAccessControlledResource({
    name: 'BulkP2PTransferViaFileButton',
    rules: new PoliciesAccessRule([agentPolicy]),
});

export const BulkP2PTransferViaFileButton = withAccessCheck(BulkP2PTransferViaFileButtonInner, resource, AccessControlIndicator.Disabled);
